import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, updateData, activateData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { setSelectionRange } from '@testing-library/user-event/dist/utils';

const WorkDetailsCreate = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        gstRate: '',
        isSubmit: false,
    });

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [gstError, setGstError] = useState('');

    const [UomOptions, setUomOptions] = useState([]);
    const [selecteduom, setSelectedUom] = useState("");

    const fetchUOM = async () => {
        try {
            const response = await fetchData('UOMApi', `/${companyId}`, token); //, token
            if (response.responseCode === '1111') {
                const options = response.response_data.map(WrokData => ({
                    value: WrokData.Id,
                    label: WrokData.Name
                }));
                setUomOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleUOMChange = (selectedOption) => {
        setSelectedUom(selectedOption);
    };

    // WorkItem
    const [WorkOptions, setWorkOptions] = useState([]);
    const [selectedWork, setSelectedWork] = useState("");

    useEffect(() => {
        const fetchWork = async () => {
            if (!id) return; // only fetch if workId is available
            try {
                const response = await fetchData('WorkItemApi', `/CreatedSubWorkItemList/${id}`, token);
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(WorkData => ({
                        value: WorkData.Id,
                        label: WorkData.Description
                    }));
                    setWorkOptions(options);
                }
            } catch (error) {
                console.error('Error fetching work items:', error);
            }
        };

        fetchWork();
    }, [id, token]);

    const handleWorkChange = (selectedOption) => {
        setSelectedWork(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            CompanyId: companyId,
            WorkItemId: selectedOption.value,
        }));
    };

    const [newRecordData, setNewRecordData] = useState({
        CompanyId: companyId,
        WorkId: '',
        WorkItemId: '',
        UnitofMeasuresId: '',
        Name: '',
        Description: '',
        Rate: '0',
        GSTRate: '0',
        HSNCode: '',
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

    const [updatedData, setUpdateData] = useState({
        CompanyId: companyId,
        WorkId: '',
        WorkItemId: '',
        UnitofMeasuresId: '',
        Name: '',
        Description: '',
        Rate: '0',
        GSTRate: '0',
        HSNCode: '',
    });

    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    useEffect(() => {
        fetchData('WorkApi', `/WorkDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Work Details:', error);
            });
        fetchItemData();
    }, [id]);

    const fetchItemData = async () => {
        setLoading(true);
        fetchData('WorkDetailsApi', `/CreatedSubWorkDetailsList/${id}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Work Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    useEffect(() => {
        fetchUOM();
        fetchItemData();
    }, []);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const addRecord = async () => {
        newRecordData.CompanyId = companyId;
        const UOM = selecteduom.label;
        const UnitofMeasuresId = selecteduom.value;
        const WorkId = id;
        const WorkItemId = selectedWork.value;
        newRecordData.WorkItemId = WorkItemId
        newRecordData.UnitofMeasuresId = UnitofMeasuresId;
        newRecordData.WorkId = WorkId;

        //  Name validation
        if (!newRecordData.Description) {
            setErrorMessage('Description is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        // if (!newRecordData.HSNCode) {
        //     setErrorMessage('HSNCode is required ! Please fill all required fields.');
        //     setIsLoading(false);
        //     return;
        // }

        if (!newRecordData.UnitofMeasuresId) {
            setErrorMessage('UOM is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        try {
            await postData('WorkDetailsApi', newRecordData, token);
            setNewRecordData({
                CompanyId: companyId,
                WorkId: '',
                WorkItemId: '',
                UnitofMeasuresId: '',
                Description: '',
                Rate: '0',
                GSTRate: '0',
                HSNCode: '',
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
            });
            fetchItemData();
            setIsModalOpen(false);
            setSelectedUom('');
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    const handleDelete = async () => {
        deleteData('WorkDetailsApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchItemData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const openDetailModal = async (item) => {
        try {
            const response = await fetchData('WorkDetailsApi', `/SubWorkDetails/${item.Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Work Details:', error);
        }
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const updateRecord = async (event) => {
        event.preventDefault();

        updatedData.UnitofMeasuresId = selecteduom.value;

        if (!updatedData) {
            console.error('No Work Details selected.');
            return;
        }
        try {
            await updateData('WorkDetailsApi', `${updatedData.Id}`, updatedData, token); //, token
            setUpdateData({
                CompanyId: companyId,
                WorkId: '',
                WorkItemId: '',
                UnitofMeasuresId: '',
                Description: '',
                Rate: '0',
                GSTRate: '0',
                HSNCode: '',
                UpdatedBy: userId,
                UpdatedDate: new Date().toISOString(),
            });
            fetchItemData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>
                <div className='w-full mb-2 flex'>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '20px', marginTop: '-25px' }}>Item Details</h6>
                    <Button
                        onClick={toggleModal}
                        style={{
                            background: 'rgba(116, 238, 126, 0.3)',
                            color: 'black',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            borderRadius: '15px'
                        }}
                    >
                        Add Record
                    </Button>

                    <Button
                        component={Link}
                        to="/WorkIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgba(248, 168, 168, 1),rgba(242, 202, 196, 1))',
                            color: 'black',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            borderRadius: '15px',
                        }}
                    >
                        Back To List
                    </Button>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                <br></br>
                <div className="w-full flex flex-wrap" style={{ marginTop: '-10px' }}>
                    <div className="w-full pl-4" style={{ width: '100%', marginTop: '-50px' }}>
                        <div className="bg-white rounded-lg shadow-lg p-6">
                            <div className="w-full mb-5 flex" style={{ marginTop: '-10px' }}>
                                <h3 className="text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'monospace', textTransform: 'uppercase' }}>{formData.Name}</h3>
                                {loading && (
                                    <div style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 9999
                                    }}>
                                        <div>
                                            <CircularProgress style={{ color: 'white' }} />
                                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                                        </div>
                                    </div>
                                )}

                                {isModalOpen && (
                                    <div className="fixed inset-0 flex items-center justify-center z-10">
                                        <div className="p-6 rounded-lg shadow-lg" style={{ width: '90%', background: '#f7ebe1ff' }}>
                                            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                                            <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '20px', textAlign: 'center' }}>Item Details Create</h6>
                                            <div className="w-full mb-4 flex">
                                                <div className="w-1/3 mr-2">
                                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                                        Item<span className="text-red-500">*</span>
                                                    </label>
                                                    <Select
                                                        value={selectedWork}
                                                        onChange={handleWorkChange}
                                                        options={WorkOptions}
                                                        placeholder="Select Item"
                                                        isSearchable
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: '30px',
                                                                height: '30px',
                                                                fontSize: '12px',
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 1301,
                                                                fontSize: '12px',
                                                            }),
                                                            indicatorsContainer: (base) => ({
                                                                ...base,
                                                                height: '30px',
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                                {/* UOM */}
                                                <div className="w-1/6 mr-2">
                                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                        UOM<span className="text-red-500">*</span>
                                                    </label>
                                                    <Select
                                                        value={selecteduom}
                                                        onChange={handleUOMChange}
                                                        options={UomOptions}
                                                        placeholder="UOM"
                                                        isSearchable
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: '30px',
                                                                height: '30px',
                                                                fontSize: '12px',
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 1301,
                                                                fontSize: '12px',
                                                            }),
                                                            indicatorsContainer: (base) => ({
                                                                ...base,
                                                                height: '30px',
                                                            }),
                                                        }}
                                                    />
                                                </div>


                                                <div className="w-1/3 mr-2">
                                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                        Name<span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                        value={newRecordData.Name}
                                                        onChange={handleInputChange}
                                                        type="text"
                                                        placeholder="Name"
                                                        name='Name'
                                                    //onClick={(e) => e.target.select()}
                                                    />
                                                </div>
                                                {/* HSN Code */}
                                                <div className="w-1/4 mr-2"> 
                                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                        HSN Code
                                                        {/* <span className="text-red-500">*</span> */}
                                                    </label>
                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                        value={newRecordData.HSNCode}
                                                        onChange={handleInputChange}
                                                        type="text"
                                                        placeholder="HSN Code"
                                                        name='HSNCode'
                                                    />
                                                </div>

                                                {/* GST Rate */}
                                                <div className="w-1/4 mr-2">
                                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                        GST Rate
                                                    </label>
                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                        value={newRecordData.GSTRate}
                                                        onChange={handleInputChange}
                                                        type="number"
                                                        placeholder="GST Rate"
                                                        name='GSTRate'
                                                    />
                                                </div>

                                                {/* Rate */}
                                                <div className="w-1/4">
                                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                        Rate
                                                    </label>
                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                        value={newRecordData.Rate}
                                                        onChange={handleInputChange}
                                                        type="number"
                                                        placeholder="Rate"
                                                        name='Rate'
                                                    />
                                                </div>
                                            </div>

                                            {/* Description */}
                                            <div className="w-full mb-3">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                    Description<span className="text-red-500">*</span>
                                                </label>
                                                <textarea
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    value={newRecordData.Description}
                                                    onChange={handleInputChange}
                                                    placeholder="Description"
                                                    name='Description'
                                                    rows={5}
                                                />
                                            </div>

                                            <div className="flex mt-4" style={{ justifyContent: 'center' }}>
                                                {/* Add Record Button */}
                                                <button
                                                    onClick={addRecord}
                                                    style={{
                                                        backgroundColor: '#088b11ff',
                                                        color: '#ffffff',
                                                        padding: '6px 12px',
                                                        fontSize: '13px',
                                                        height: '32px',
                                                        borderRadius: '6px',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        transition: 'transform 0.15s ease, background-color 0.2s ease',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.transform = 'scale(1.04)';
                                                        e.target.style.backgroundColor = '#1e9304ff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.transform = 'scale(1)';
                                                        e.target.style.backgroundColor = '#09a628ff';
                                                    }}
                                                >
                                                    Add Record
                                                </button>

                                                {/* Cancel Button */}
                                                <button
                                                    onClick={toggleModal}
                                                    style={{
                                                        backgroundColor: '#64748b', // modern cool gray
                                                        color: '#ffffff',
                                                        padding: '6px 12px',
                                                        fontSize: '13px',
                                                        height: '32px',
                                                        borderRadius: '6px',
                                                        border: 'none',
                                                        marginLeft: '8px',
                                                        cursor: 'pointer',
                                                        transition: 'transform 0.15s ease, background-color 0.2s ease',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.transform = 'scale(1.04)';
                                                        e.target.style.backgroundColor = '#475569';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.transform = 'scale(1)';
                                                        e.target.style.backgroundColor = '#64748b';
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>

                            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto', width: '100%', marginTop: '-65px' }}>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {['Sl.No', 'HSN Code', 'Item', 'Name', 'Description', 'GST %', 'Rate', 'UOM', ''].map((title, idx) => (
                                                    <TableCell
                                                        key={idx}
                                                        sx={{
                                                            backgroundColor: '#242023ff',
                                                            color: 'white',
                                                            fontWeight: '600',
                                                            fontSize: '12px',
                                                            border: '1px solid #ccc',
                                                            textAlign: 'center',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 10,
                                                            whiteSpace: 'nowrap',
                                                            padding: '3px',
                                                            borderRadius: '5px'
                                                        }}
                                                    >
                                                        {title}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(data) && data.length > 0 ? (
                                                data.map((item, index) => (
                                                    <TableRow key={item.Id}>
                                                        <TableCell sx={{ padding: '2px', fontSize: '12.5px' }}>{index + 1}</TableCell>
                                                        <TableCell sx={{ padding: '2px', fontSize: '12.5px' }}>{item.HSNCode}</TableCell>
                                                        <TableCell sx={{ padding: '2px', fontSize: '12.5px' }}>{item.WorkItemName}</TableCell>
                                                        <TableCell sx={{ padding: '2px', fontSize: '12.5px' }}>{item.Name}</TableCell>
                                                        <TableCell sx={{ padding: '2px', width: '50%', fontSize: '12.5px' }}>{item.Description}</TableCell>
                                                        <TableCell sx={{ padding: '2px', textAlign: 'right', fontSize: '12.5px' }}>{Number(item.GSTRate)}</TableCell>
                                                        <TableCell sx={{ padding: '2px', textAlign: 'right', fontSize: '12.5px' }}>{item.Rate}</TableCell>
                                                        <TableCell sx={{ padding: '2px', textAlign: 'right', fontSize: '12.5px' }}>{item.UOM}</TableCell>
                                                        <TableCell className="customTableCell" sx={{ padding: '2px', width: '150px', textAlign: 'center' }}>
                                                            <IconButton onClick={() => openDetailModal(item)}>
                                                                <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold', height: '20px' }} />
                                                            </IconButton>
                                                            <IconButton onClick={() => openConfirmDialog(item.Id)}>
                                                                <DeleteIcon style={{ color: 'brown', fontWeight: 'bold', height: '20px' }} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={6} sx={{ textAlign: 'center', padding: '8px', fontStyle: 'italic', color: 'gray' }}>
                                                        No Subworks
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <Dialog
                                            open={confirmDialogOpen}
                                            onClose={closeConfirmDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Are you sure you want to delete this record?
                                                </DialogContentText>
                                            </DialogContent>

                                            <DialogActions>
                                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                                    Cancel
                                                </button>
                                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                                    Confirm
                                                </button>
                                            </DialogActions>
                                        </Dialog>
                                    </Table>
                                </TableContainer>
                            </div>

                            {isDetailModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center z-10">
                                    <div className="p-6 rounded-lg shadow-lg" style={{ width: '90%', background: '#f7ebe1ff' }}>
                                        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '20px', textAlign: 'center' }}>Item Details Edit</h6>
                                        <div className="w-full mb-4 flex">
                                            <div className="w-1/3 mr-2">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                                    Item<span className="text-red-500">*</span>
                                                </label>
                                                <Select
                                                    value={selectedWork || (updatedData.WorkItemName ? { value: updatedData.WorkItemId, label: updatedData.WorkItemName } : '')}
                                                    onChange={handleWorkChange}
                                                    options={WorkOptions}
                                                    placeholder="Select Item"
                                                    isSearchable
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '30px',
                                                            height: '30px',
                                                            fontSize: '12px',
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 1301,
                                                            fontSize: '12px',
                                                        }),
                                                        indicatorsContainer: (base) => ({
                                                            ...base,
                                                            height: '30px',
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            {/* UOM */}
                                            <div className="w-1/6 mr-2">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                    UOM<span className="text-red-500">*</span>
                                                </label>
                                                <Select
                                                    //value={selecteduom}
                                                    value={selecteduom || (updatedData.UOM ? { value: updatedData.UnitofMeasuresId, label: updatedData.UOM } : '')}
                                                    onChange={handleUOMChange}
                                                    options={UomOptions}
                                                    placeholder="UOM"
                                                    isSearchable
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '30px',
                                                            height: '30px',
                                                            fontSize: '12px',
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 1301,
                                                            fontSize: '12px',
                                                        }),
                                                        indicatorsContainer: (base) => ({
                                                            ...base,
                                                            height: '30px',
                                                        }),
                                                    }}
                                                />
                                            </div>

                                            <div className="w-1/4 mr-2">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                    Name<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                    value={updatedData.Name}
                                                    onChange={handleUpdateInputChange}
                                                    type="text"
                                                    placeholder="Name"
                                                    name='Name'
                                                // onClick={(e) => e.target.select()}
                                                />
                                            </div>
                                            {/* HSN Code */}
                                            <div className="w-1/4 mr-2">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                    HSN Code 
                                                    {/* <span className="text-red-500">*</span> */}
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                    value={updatedData.HSNCode}
                                                    onChange={handleUpdateInputChange}
                                                    type="text"
                                                    placeholder="HSN Code"
                                                    name='HSNCode'
                                                // onClick={(e) => e.target.select()}
                                                />
                                            </div>

                                            {/* GST Rate */}
                                            <div className="w-1/4 mr-2">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                    GST Rate
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                    value={updatedData.GSTRate}
                                                    onChange={handleUpdateInputChange}
                                                    type="number"
                                                    placeholder="GST Rate"
                                                    name='GSTRate'
                                                // onClick={(e) => e.target.select()}
                                                />
                                            </div>

                                            {/* Rate */}
                                            <div className="w-1/4">
                                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                    Rate
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                                    value={updatedData.Rate}
                                                    onChange={handleUpdateInputChange}
                                                    type="number"
                                                    placeholder="Rate"
                                                    name='Rate'
                                                //  onClick={(e) => e.target.select()}
                                                />
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div className="w-full mb-3">
                                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" style={{ fontFamily: 'monospace' }}>
                                                Description<span className="text-red-500">*</span>
                                            </label>
                                            <textarea
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={updatedData.Description}
                                                onChange={handleUpdateInputChange}
                                                placeholder="Description"
                                                name='Description'
                                                rows={5}
                                            //  onClick={(e) => e.target.select()}
                                            />
                                        </div>


                                        <div className="flex mt-4" style={{ justifyContent: 'center' }}>
                                            {/* Add Record Button */}
                                            <button
                                                onClick={updateRecord}
                                                style={{
                                                    backgroundColor: '#b35e15ff',
                                                    color: '#ffffff',
                                                    padding: '6px 12px',
                                                    fontSize: '13px',
                                                    height: '32px',
                                                    borderRadius: '6px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    transition: 'transform 0.15s ease, background-color 0.2s ease',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'scale(1.04)';
                                                    e.target.style.backgroundColor = '#b06a0dff';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'scale(1)';
                                                    e.target.style.backgroundColor = '#a66f09ff';
                                                }}
                                            >
                                                Update Details
                                            </button>

                                            {/* Cancel Button */}
                                            <button
                                                onClick={toggleModalBranch}
                                                style={{
                                                    backgroundColor: '#64748b',
                                                    color: '#ffffff',
                                                    padding: '6px 12px',
                                                    fontSize: '13px',
                                                    height: '32px',
                                                    borderRadius: '6px',
                                                    border: 'none',
                                                    marginLeft: '8px',
                                                    cursor: 'pointer',
                                                    transition: 'transform 0.15s ease, background-color 0.2s ease',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'scale(1.04)';
                                                    e.target.style.backgroundColor = '#475569';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'scale(1)';
                                                    e.target.style.backgroundColor = '#64748b';
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div >
            </div >
        </Fragment >
    );
};

export default WorkDetailsCreate;

